/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import api from 'api';

import groupActions from 'redux/actions/group';
import navigationActions from 'redux/actions/navigation';
import sessionActions from 'redux/actions/session';
import userActions from 'redux/actions/user';
import uiStateActions from 'redux/actions/uiState';

import userSelectors from 'redux/reduxStore/user';
import profileSelectors from 'redux/reduxStore/profile';
import groupSelectors from 'redux/reduxStore/group';

import SetPasswordPresenter from '../SetPassword/SetPassword.presenter';
import MfaCodeEntry from 'components/pages/mfaCode';

import routeNames from 'lib/routeNames';
import PasswordStrength from 'lib/PasswordStrength';

function mapStateToProps(state) {
  const user = userSelectors.getLoggedInUser(state);
  const group = groupSelectors.getActiveGroup(state);
  return {
    groupId: group.id || -1,
    organizationName: group.organization_name || '',
    isMfaRequired: user.mfa_enabled === 1,
    userId: user.id,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goHome: () => {
      dispatch(navigationActions.goBackTo(routeNames.home()));
    },
    updateUser: (user) => {
      dispatch(userActions.updateUser(user));
    },
    showApiError: (apiError) => {
      dispatch(uiStateActions.showApiError(apiError));
    },
    login: (accessToken) => {
      dispatch(sessionActions.loginSuccessful(accessToken));
    },
    logout: () => {
      dispatch(sessionActions.logout());
      dispatch(navigationActions.goTo(routeNames.loginEmail()));
    },
    fetchGroup: (groupId) => {
      return dispatch(groupActions.request(groupId));
    }
  }
}

class ResetPassword extends React.Component {

  constructor(props) {
    super(props);

    this.resetPassword = this.resetPassword.bind(this);
    this.resetPasswordMfa = this.resetPasswordMfa.bind(this);

    this.state = {
      passwordSubmitted: false,
      resetPasswordSuccess: false,
    };
  }

  resetPassword(token, password, isMfaRequired) {
    this.setState({
      passwordSubmitted: true,
    });

    if (isMfaRequired) { return; }

    api.passwordApi.update(token, password)
      .then(user => {
        this.props.updateUser(user);

        return api.sessionApi.login({
          email: user.email,
          password,
          duration: 'short',
          groupId: this.props.groupId,
        })
      })
      .then((accessToken) => {
        this.setState({ resetPasswordSuccess: true });
        this.props.login(accessToken);
      })
      .catch(() => this.props.logout());
  }

  resetPasswordMfa(token, password, mfaCode) {
    let accessToken;

    return api.sessionApi.mfaForgotPassword(token, password, mfaCode, 'short')
      .then((a) => {
        accessToken = a;
        this.props.login(accessToken);
        return api.userApi.get(this.props.userId);
      })
      .then((user) => this.props.updateUser(user))
      .then(() => {
        this.props.login(accessToken);
        return this.props.fetchGroup(this.props.groupId);
      })
      .catch(() => this.props.logout())
      .then(() => this.props.goHome())
      .catch(this.props.showApiError);
  }

  render() {
    return (
      <SetPasswordPresenter
        token={this.props.token}
        resetPassword={this.resetPassword}
        resetPasswordMfa={this.resetPasswordMfa}
        resetPasswordSuccess={this.state.resetPasswordSuccess}
        passwordSubmitted={this.state.passwordSubmitted}
        cancelPassword={() => { this.setState({ passwordSubmitted: false }); }}
        titlePhrase={{ id: 'setPwd.title.text' }}
        isMfaRequired={this.props.isMfaRequired}
        organizationName={this.props.organizationName}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);